// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DisplayPreferencesPanel_wrapper___9JcD","section":"DisplayPreferencesPanel_section__UPzpu","legendDescription":"DisplayPreferencesPanel_legendDescription__Uudpa"};